<template>
  <div class="search-select" v-click-outside="close">
    <input
      class="form-control"
      type="text"
      autocomplete="off"
      v-model="query"
      :placeholder="placeholder"
      @focus="onFocus"
      @input="open = true"
    />
    <ul v-if="open && filtered.length" class="list-group search-select-dropdown">
      <li
        v-for="opt in filtered"
        :key="String(opt.value)"
        class="list-group-item list-group-item-action"
        :class="{ active: opt.value == value }"
        @mousedown.prevent="select(opt)"
      >
        {{ opt.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SearchSelect",
  props: {
    options: { type: Array, default: () => [] },
    value: { default: null },
    placeholder: { type: String, default: "输入关键字筛选..." }
  },
  data() {
    return { query: "", open: false };
  },
  computed: {
    // 过滤掉占位项(无 value 的选项, 如 "Select a router")
    realOptions() {
      return this.options.filter(o => o.value !== null && o.value !== undefined && o.value !== "");
    },
    filtered() {
      const list = this.realOptions;
      // 聚焦后未修改输入(与当前选中值一致或为空) → 显示全部; 用户输入了新内容才过滤
      if (!this.query || this.query === this.selectedLabel) return list;
      const q = String(this.query).toLowerCase();
      return list.filter(o => String(o.label || "").toLowerCase().indexOf(q) >= 0);
    },
    selectedLabel() {
      const found = this.realOptions.find(o => o.value == this.value);
      return found ? found.label : "";
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.query = this.selectedLabel;
      }
    }
  },
  methods: {
    onFocus() {
      this.query = this.selectedLabel;
      this.open = true;
      this.$nextTick(() => {
        if (this.$el.querySelector("input")) {
          this.$el.querySelector("input").select();
        }
      });
    },
    select(opt) {
      this.$emit("input", opt.value);
      this.$emit("change", opt.value);
      this.query = opt.label;
      this.open = false;
    },
    close() {
      this.open = false;
      this.query = this.selectedLabel;
    }
  },
  directives: {
    "click-outside": {
      bind(el, binding) {
        el.__clickOutside__ = (e) => {
          if (!(el === e.target || el.contains(e.target))) {
            binding.value(e);
          }
        };
        document.addEventListener("mousedown", el.__clickOutside__);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el.__clickOutside__);
      }
    }
  }
};
</script>

<style scoped>
.search-select {
  position: relative;
}
.search-select-dropdown {
  position: absolute;
  z-index: 2000;
  width: 100%;
  max-height: 260px;
  overflow-y: auto;
  font-size: 0.875rem;
  cursor: pointer;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0,0,0,.25);
}
.search-select-dropdown >>> li {
  background-color: #ffffff;
  border-color: #ebedef;
}
.search-select-dropdown >>> li.active {
  background-color: #321fdb;
  border-color: #321fdb;
  color: #ffffff;
}
</style>
